import React from "react";

const SingleDatePicker = ({ filters, setFilters }) => {
  const handleChangeDate = (e) => {
    const { value } = e.target;

    setFilters((prevs) => ({
      ...prevs,
      selectedStartDate: value,
      selectedEndDate: value,
    }));
  };

  return (
    <div
      className={`single-date-picker commonWrapper dropdownCommonWrapper darerangerCommonWrapper span2 ${
        filters?.selectedStartDate || filters?.selectedEndDate
          ? "redBorderRedText"
          : ""
      }`}
    >
      <input
        type="date"
        className={`${filters.selectedStartDate ? "date-has-value" : ""}`}
        value={filters.selectedStartDate}
        onChange={handleChangeDate}
      />
    </div>
  );
};

export default SingleDatePicker;
